// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "g.replica path[data-v-53b38bdf] {\n  fill: #7dd012;\n}\ng.primary path[data-v-53b38bdf] {\n  fill: #eb5757;\n}\ng.green-arrow path[data-v-53b38bdf] {\n  stroke: #7dd012;\n}\ng.red-arrow path[data-v-53b38bdf] {\n  stroke: #eb5757;\n}", ""]);
// Exports
module.exports = exports;
